import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IMetricUsageInfo } from '../../../ts/ServerApi/types/IUsageInfo';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { INamedItem, ITypedItem } from '../../../ts/ServerApi/types/resourceParts';
import { IConnectedView, IMetric } from '../types/IMetric';

export interface IGetMetricsParams extends IGetItemsParams {
}

export interface IGetMetricsResult extends IGetItemsResult {
  metrics?: IMetric[];
  users?: IUser[];
  connectedViews: IConnectedView[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  favorites?: string[];
  maxStats?: IMetricUsageInfo;
}

export class GetMetricsRequest extends Request<IGetMetricsParams, IGetMetricsResult> {
  constructor(params: IGetMetricsParams) {
    super('getMetrics', params);
  }
}
